module.exports = __webpack_public_path__ + "img/restaurant.fff8967a.webp";